/**
  *
  * Usage:
  *
  *   data-sw-custom-list=<list-name>
  *
  * @subscribes fancy-box-content-loaded <$fancy-box-element>
  *
  */

var _ = require('underscore');
var $ = require('../sw-jquery');
var CustomListForm = require('./../../lib/views/CustomListForm');
var notifications = require('js/lib/notifications/sw-notifications');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-custom-list]').each(function() {

    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {

      var spin = $el.data('swCustomList');
      var reloadOnSuccess = !_.isUndefined($el.data('swCustomListSuccessReload'));
      var product = ModelManager.getProduct(spin);

      function successCallback(response) {
        var splitPath;
        var listPathVal;
        // FML and lack of standardized responses
        var data = response.data ? response.data : response;

        if(reloadOnSuccess) {
          splitPath = document.location.pathname.split('/');
          listPathVal = splitPath[splitPath.length - 1];
          if(listPathVal === 'lists') {
            document.location.reload();
          } else {
            document.location.href = document.location.href.replace(listPathVal, data.listUri);
          }
          return;
        }

        var message = data.successMessage ? data.successMessage : 'Success!';

        notifications.success(message);

      }

      function errorCallback(data) {
        notifications.error(data.errorMessage);
      }

      new CustomListForm({
        el: $el,
        model: product,
        addItemSuccessCallback: successCallback,
        deleteItemSuccessCallback: function() {
          var splitPath;
          var listPathVal;
          if(reloadOnSuccess) {
            splitPath = document.location.href.split('/');
            listPathVal = splitPath[splitPath.length - 1];
            if(listPathVal === 'lists') {
              document.location.reload();
            } else {
              splitPath.pop();
              document.location.href = splitPath.join('/');
            }
            return;
          }
        },
        deleteItemFailCallback: errorCallback,
        onSubmitSuccessCallback: successCallback,
        addItemErrorCallback: errorCallback,
        onSubmitErrorCallback: errorCallback
      });

    });

  });

};
